<template>
  <a-card :bordered="false" title="设置规则">
    <div class="title">
      <span style="margin-right: 10px;">红包奖励规则</span>
      <span>提示：不在时间范围内不派发，红包余额不足不派发 </span>
    </div>
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="isDf">
      <a-form-model-item label="发送者名称" prop="redSendName" v-bind="formItemLayout">
        <a-input v-model="ruleForm.redSendName" :maxLength="10" placeholder="请输入发送者名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="红包金额" prop="redAmount" v-bind="formItemLayout">
        <a-input v-model="ruleForm.redAmount" :maxLength="10" placeholder="1-200"></a-input>
      </a-form-model-item>
      <a-form-model-item label="红包祝福语" prop="redBlessings" v-bind="formItemLayout">
        <a-input v-model="ruleForm.redBlessings" placeholder="请输入红包祝福语" :maxLength="12"></a-input>
      </a-form-model-item>
      <a-form-model-item label="活动时间" v-bind="formItemLayout" required>
        <a-range-picker
          :disabledDate="disabledDate"
          format="YYYY-MM-DD 00:00"
          :value="value"
          style="margin-right: 12px;"
          :mode="mode"
          @calendarChange="handlePanelChange"
          @change="onChange"
          @openChange="openChange"
        />
      </a-form-model-item>
      <a-form-model-item label="发送规则" required v-bind="formItemLayout">
        <a-radio-group v-model="ruleForm.redRule">
          <div style="margin-bottom: 20px;">
            <a-radio class="select" value="1">
              <span>新注册二级分销商商店铺，累计前</span>
              <span
              ><a-input v-model="redOrderNum1" :maxLength="10" style="width: 100px; padding: 0 15px;"></a-input
              ></span>
              <span>笔成交订单，每笔成交后发放1次</span>
            </a-radio>
          </div>
          <div>
            <a-radio class="select" value="2">
              <span>所有二级分销商，每写成</span>
              <span
              ><a-input v-model="redOrderNum2" :maxLength="10" style="width: 100px; padding: 0 15px;"></a-input
              ></span>
              <span>笔成交订单后发放1次</span>
            </a-radio>
          </div>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-bind="formItemLayoutBtn">
        <a-button v-if="isClick" type="primary" @click="submitForm('ruleForm')">提 交</a-button>
        <a-button v-else disabled>提 交</a-button>
        <a-button style="margin-left: 10px;" @click="back">返 回</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RedpacketSet',
  data() {
    var checkMoney = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > Number(200)) {
          callback(new Error('金额必须要小于200元'))
        } else if (Number(value) < 1) {
          callback(new Error('金额必须大于1元'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkEndTime = (rule, value, callback) => {
      setTimeout(() => {
        if (Date.parse(new Date(value)) < Date.parse(new Date())) {
          callback('结束时间需大于当前时间')
        } else {
          callback()
        }
      }, 1000)
    }
    var checkTimeDate = (rule, value, callback) => {
      if (Date.parse(new Date(value)) < Date.parse(new Date(this.ruleForm.redEndTime))) {
        callback('结束时间需大于开始时间')
      } else {
        callback()
      }
    }
    return {
      formItemLayoutBtn: {
        wrapperCol: {
          xxl: { offset: 2 },
          xl: { offset: 3 },
          lg: { offset: 4 },
          sm: { offset: 4 },
          md: { offset: 7 },
          xs: { offset: 9 }
        }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 4 },
          sm: { span: 4 },
          md: { span: 7 },
          xs: { span: 9 }
        },
        wrapperCol: {
          xxl: { span: 11 },
          xl: { span: 10 },
          lg: { span: 9 },
          sm: { span: 9 },
          md: { span: 6 },
          xs: { span: 6 }
        }
      },
      isDf: false,
      isClick: true,
      mode: ['date', 'date'],
      value: [],
      startTime: '',
      endTime: '',
      startValue: '',
      radioValue: 1,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      redOrderNum1: 10,
      redOrderNum2: 10,
      ruleForm: {
        redAmount: '', //红包金额
        redBlessings: '', //红包祝福语
        redEndTime: '', //活动结束时间
        redMerchantId: this.$store.getters.userInfo.merchantId,
        redOrderNum: 0, //发送规则内订单数量
        redPlatformId: this.getPlatformConfig().platformId,
        redRule: 1, //发送规则（1，新注册二分，2，全部二分） ,
        redSendName: '', //发送者名称
        redStrTime: '', // 活动开始时间
        redId: null
      },
      rules: {
        redSendName: [{ required: true, message: '请输入发送者名称', trigger: 'blur' }],
        redAmount: [
          { required: true, message: '请输入红包金额', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ],
        redBlessings: [{ required: true, message: '请输入红包祝福语', trigger: 'blur' }],
        couponGetLimitNum: [
          { required: true, message: '请选择最多领取数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的领取数', trigger: 'blur' }
        ],
        redStrTime: [{ required: true, message: '请选择活动开始日期', trigger: 'change' }],
        redEndTime: [
          { required: true, message: '请选择领取结束日期', trigger: 'change' },
          { validator: checkEndTime, trigger: 'change' },
          { validator: checkTimeDate, trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'RedEnvelopes', title: '红包' }
    ])
  },
  methods: {
    onChange(dates, dateStrArr) {
      this.value = dates
      this.ruleForm.redStrTime = dateStrArr[0]
      this.ruleForm.redEndTime = dateStrArr[1]
    },
    handlePanelChange(value) {
      this.startValue = value[0]._d
      if (value[0] && value[1]) {
        this.startTime = moment(value[0]._d).format('YYYY-MM-DD 00:00')
        this.endTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD 00:00')
        this.isChange = -1
        this.titleHeader = ''
        this.getLogUtils().logWithTag('this.startTime', this.startTime)
        this.getLogUtils().logWithTag('this.endTime', this.endTime)
      }
    },
    //禁选开始时间前后31天
    disabledDate(current) {
      let days = moment()
        .endOf('day')
        .valueOf()
      if (current.valueOf() < days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() < new Date(this.startValue).getTime()
    },
    //日期选择框关闭回调
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    //验证
    checkForm() {
      if (this.ruleForm.redRule == 1) {
        if (!this.redOrderNum1) {
          this.$message.error('请输入累计订单数')
          return false
        }
        if (this.redOrderNum1) {
          if (!/^[1-9]\d*$/.test(this.redOrderNum1)) {
            this.$message.error('请输入正确的累计订单数')
            return false
          }
          if (this.redOrderNum1 > 50 && this.redOrderNum1 < 1) {
            this.$message.error('请输入正确的累计订单数')
            return false
          }
        }
      }
      if (this.ruleForm.redRule == 2) {
        if (!this.redOrderNum2) {
          this.$message.error('请输入累计订单数')
          return false
        }
        if (this.redOrderNum2) {
          if (!/^[1-9]\d*$/.test(this.redOrderNum2)) {
            this.$message.error('请输入正确的累计订单数')
            return false
          }
          if (this.redOrderNum2 > 50 && this.redOrderNum2 < 1) {
            this.$message.error('请输入正确的累计订单数')
            return false
          }
        }
      }
      return true
    },
    //设置提交
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.saveData()
        } else {
          this.getLogUtils().logWithTag('error submit', 'error submit!!')
          this.$message.error('有必填项未处理')
          return false
        }
      })
    },
    //保存接口
    saveData() {
      this.isClick = false
      if (this.ruleForm.redRule == 1) {
        this.ruleForm.redOrderNum = this.redOrderNum1
      }
      if (this.ruleForm.redRule == 2) {
        this.ruleForm.redOrderNum = this.redOrderNum2
      }
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices()
        .getServerApiService()
        .post('redEnvelopes/add', this.submitFormData)
        .then(res => {
          this.$message.success('红包设置成功')
          setTimeout(() => {
            this.back()
          }, 500)
        })
        .catch(err => {
          this.isClick = true
          this.$message.error(err.msg)
        })
    },
    radioChange(e) {
      this.radioValue = e
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.title {
  margin-bottom: 20px;
  line-height: 22px;
}

.select {
  font-size: 10px;
  line-height: 32px;
}
</style>
